import { Meeting } from "@api/models/meetings/Meeting";
import {Element} from "@api/models/Element";
import { StoreHelper } from "@share/web-conferences/helpers/StoreHelper";
import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { isSchemaMeeting } from "@share/web-conferences/helpers/isSchemaMeeting";
import VueRouter from "vue-router";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

export class RecordingController {
    isBeingRecorded = false;
    showRecordingButton = false;

    constructor(
        private readonly schemaId: string,
        private readonly element: Meeting | Element,
        private readonly storeHelper: StoreHelper,
        private readonly meetingRepository: MeetingRepository,
    ) {

    }

    initShowRecordingButton(route: VueRouter | null = null)
    {
        this.showRecordingButton = isSchemaMeeting(this.schemaId) && (route == null || route.currentRoute.name == RouteNamesEnum.viewMeetingPublic);
    }

    get canControlRecording(): boolean
    {
        return this.element.ownerId == this.storeHelper.store.getters.userId;
    }

    test() {
        return new Promise((resolve) =>{
            setTimeout(() => resolve(true), 2000);
        })
    }

    async start() {
        try {
            await this.meetingRepository.startRecording(this.element.id);
            // await this.test();
            this.isBeingRecorded = true;
        }
        catch (e) {
            this.storeHelper.store.dispatch('reportException', e);
        }
    }

    async stop() {
        try {
            await this.meetingRepository.stopRecording(this.element.id);
            // await this.test();
            this.isBeingRecorded = false;
        }
        catch (e) {
            this.storeHelper.store.dispatch('reportException', e);
        }
    }

    async toggle() {
        if (this.isBeingRecorded) {
            await this.stop();
        }
        else {
            await this.start();
        }
    }
}